<script setup>
import { onMounted, ref } from 'vue';
import { useFelixBagAuxStore } from '../../../store';

import ModalConfirmacao from './components/ModalConfirmacao.vue';
const felixBagAuxStore = useFelixBagAuxStore();

const showModalConfirmacao = ref(false)
const dataChegada = ref('')

function confirmarClicked() {
  showModalConfirmacao.value = true;
  felixBagAuxStore.saveEvent('o_grande_dia_chegou', 'form_submit', dataChegada.value)
}

onMounted(() => {
  felixBagAuxStore.pauseAfter(1000)
});

</script>

<template>
  <div id="solicitar-licensa">
    <div class="header">
      <v-btn @click="felixBagAuxStore.seekTo(felixBagAuxStore.scenes.menu)" variant="text" class="close">
        <img
          src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/f150a967-b846-491c-84e6-eb612ca40e3e.svg"
          alt="">
      </v-btn>
    </div>

    <p class="solicitar-licensa-title">O grande dia chegou!<br> Preciso solicitar licença.</p>

    <img style="width: 60%;"
      src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/2d4de3f1-9c1d-4d66-926d-4fed34fdddc9.svg"
      alt="">
    <div style="width: 85%;">
      <p class="label">Selecione abaixo a data que o novo integrante chegou?*</p>
      <input placeholder="Digite" class="input-date" type="date" name="" v-model="dataChegada" id="">
    </div>

    <v-btn @click="confirmarClicked" style="width: 85%;" color="#660099" variant="flat"
      class="text-none">Confirmar</v-btn>
  </div>

  <ModalConfirmacao v-if="showModalConfirmacao" @close-modal="showModalConfirmacao = false"/>
</template>

<style scoped>
#solicitar-licensa {
  width: 100%;
  height: 90%;
  position: absolute;
  top: 0;
  z-index: 4;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-direction: column;
}

.header {
  width: 100%;
  height: 10%;
  background-color: #BC4AFF;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}

.solicitar-licensa-title {
  color: #464646;
  font-weight: bold;
}

.label {
  font-size: 14px;
  text-align: start;
}

.input-date {
  width: 100%;
  border: 1px solid #E8E8E8;
  padding: 5px;
}
</style>